<script setup lang="tsx">
const props = withDefaults(
  defineProps<{
    width?: string;
    height?: string;
    color?: string;
  }>(),
  {
    width: "1em",
    color: "#cccccc"
  }
);
</script>

<template>
  <svg
    viewBox="0 0 20 20"
    :width="props.width"
    :height="props.height || props.width"
    style="transform-origin: center"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
      clip-rule="evenodd"
      :fill="props.color"
    />
  </svg>
</template>
